export default "__VITE_ASSET__DDIZy1C1__"